import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOnline: navigator.onLine,
    outboxCount: 0,
    isReplaying: false,
    replayError: null,
};

const offlineSlice = createSlice({
    name: 'offline',
    initialState,
    reducers: {
        setOnlineStatus: (state, action) => {
            state.isOnline = action.payload;
        },
        setOutboxCount: (state, action) => {
            state.outboxCount = action.payload;
        },
        replayStart: (state) => {
            state.isReplaying = true;
            state.replayError = null;
        },
        replaySuccess: (state) => {
            state.isReplaying = false;
        },
        replayFailure: (state, action) => {
            state.isReplaying = false;
            state.replayError = action.payload;
        },
        // Dispatched by serviceWorkerRegistration and UI — watched by offlineSaga
        triggerOutboxReplay: () => {},
    },
});

export const {
    setOnlineStatus,
    setOutboxCount,
    replayStart,
    replaySuccess,
    replayFailure,
    triggerOutboxReplay,
} = offlineSlice.actions;

export default offlineSlice.reducer;
